import styled from 'styled-components';

export const Container = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    margin: 0;

    thead th {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: ${(props) => props.theme.$gray500};
      border-top: 0;
      border-bottom: 1px solid ${(props) => props.theme.$gray300};
      white-space: nowrap;
      padding: 10px 12px;
    }

    tbody td {
      padding: 12px;
      font-size: 0.88rem;
      color: ${(props) => props.theme.$gray800};
      border-top: 1px solid ${(props) => props.theme.$gray200};
      vertical-align: top;
    }

    tbody tr {
      transition: background 0.12s;

      &:hover {
        background: ${(props) => props.theme.$gray100};
      }

      &.selected {
        background: ${(props) => props.theme.$bg_green};
      }

      &.selectable {
        cursor: pointer;
      }
    }
  }

  .desc-cell {
    min-width: 260px;
    max-width: 420px;

    .desc-main {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .desc-extra {
      margin-top: 2px;
      font-size: 0.76rem;
      color: ${(props) => props.theme.$gray500};
    }

    .edital-badge {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      margin-top: 4px;
      padding: 1px 8px;
      border-radius: 999px;
      background: ${(props) => props.theme.$bg_green};
      color: ${(props) => props.theme.$dark_green};
      font-size: 0.72rem;
      font-weight: 500;

      i {
        font-size: 12px;
      }

      &.neutral {
        background: ${(props) => props.theme.$primary_light};
        color: ${(props) => props.theme.$primary};
        cursor: help;
      }
    }
  }

  .sort-btn {
    border: 0;
    background: transparent;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font: inherit;
    letter-spacing: inherit;
    text-transform: inherit;
    color: inherit;

    i {
      font-size: 13px;
      opacity: 0.35;
    }

    &.active {
      color: ${(props) => props.theme.$gray800};

      i {
        opacity: 1;
      }
    }
  }

  .org-cell {
    min-width: 180px;
    max-width: 260px;

    .org-name {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .org-place {
      font-size: 0.76rem;
      color: ${(props) => props.theme.$gray500};
    }
  }

  .supplier-cell {
    min-width: 160px;
    max-width: 240px;

    a {
      color: ${(props) => props.theme.$primary};
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      &:hover {
        text-decoration: underline;
      }
    }

    .supplier-plain {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .value-cell {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;

    .value-main {
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    .value-normalized {
      display: block;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$dark_green};
    }
  }

  .date-cell {
    white-space: nowrap;
    color: ${(props) => props.theme.$gray600};
    font-variant-numeric: tabular-nums;
  }

  .link-cell {
    button {
      background: none;
      border: 0;
      padding: 0;
      color: ${(props) => props.theme.$gray500};
      display: inline-flex;

      &:hover {
        color: ${(props) => props.theme.$primary};
      }

      i {
        font-size: 17px;
      }
    }
  }

  .form-check-input {
    position: static;
    margin: 0;
  }
`;
